<template>
  <div>
    <contracts-dashboard v-if="isContractManager || isContractViewer" class="dashboard"></contracts-dashboard>
  </div>
</template>

<script>
import ContractsDashboard from "../../components/dashboard/contracts-dashboard";
import roleChecks from "@/misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {};
  },

  components: {
    "contracts-dashboard": ContractsDashboard
  },

  computed: {},

  created() {}
};
</script>

<style scoped>
.dashboard {
  margin-bottom: 30px;
}
.btn-primary {
  background-color: #8c1d40;
  border-color: #70112f;
}

.btn-primary:hover {
  background-color: #a02048;
}

.card-body {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
